<template>
  <router-view />
</template>

<script setup>
</script>

<style>
/* 确保整个应用的高度设置正确 */
html, body, #app {
  height: 100%;
  margin: 0;
  padding: 0;
  font-family: 'PingFang SC', 'HarmonyOS Sans SC', 'Microsoft YaHei',
               -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
               'Helvetica Neue', Arial, sans-serif;
}

/* Element Plus 菜单折叠样式优化 */
.el-menu--collapse .el-sub-menu__title span {
  display: none;
}

.el-menu--collapse .el-sub-menu__title .el-sub-menu__icon-arrow {
  display: none;
}

/* 确保菜单在折叠状态下图标居中 */
.el-menu--collapse .el-menu-item .el-icon,
.el-menu--collapse .el-sub-menu__title .el-icon {
  margin-right: 0;
}

/* 主内容区域样式优化
   内边距由 LayoutContainer 控制，这里只定底色 */
.el-main {
  background-color: var(--bg-page);
  padding: 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .el-aside {
    position: absolute;
    z-index: 1000;
    height: 100vh;
  }

  .el-main {
    margin-left: 0 !important;
  }
}

</style>
